// (function () {
//     'use strict';

//     angular.module("imApp").factory("consignmentBatchesService", ['$ihttp', function ($ihttp) {
//         let service = {
//             listBatches: function (parms) {
//                 return $ihttp.post({
//                     method: 433,
//                     parameters: parms || {}
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
